class CustomerMediaSlideshow extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#handleClick);
  }

  #handleClick = (event) => {
    const button = event.target instanceof Element ? event.target.closest('button') : null;
    if (!(button instanceof HTMLButtonElement)) return;

    const track = this.querySelector('[data-customer-media-track]');
    if (!(track instanceof HTMLElement)) return;

    const direction = button.matches('[data-customer-media-prev]') ? -1 : button.matches('[data-customer-media-next]') ? 1 : 0;
    if (!direction) return;

    const slide = track.querySelector('.customer-media-slideshow__slide');
    const amount = slide instanceof HTMLElement ? slide.offsetWidth + 8 : track.clientWidth * 0.75;

    track.scrollBy({
      left: amount * direction,
      behavior: 'smooth',
    });
  };
}

if (!customElements.get('customer-media-slideshow')) {
  customElements.define('customer-media-slideshow', CustomerMediaSlideshow);
}
